export default {
  "content": "<path fill=\"#0A1551\" d=\"M231.3 450.6c6.3 6.1 1.8 16.6-7.1 16.6H168c-11.1 0-20.1-8.7-20.1-19.4v-54.4c0-8.7 10.8-13 17.1-7l66.2 64.2z\"/><path fill=\"#FFB629\" d=\"M319 454.8a42 42 0 010-59.7l60-59.6a42.7 42.7 0 0160.1 0 42 42 0 010 59.8l-60 59.5a42.7 42.7 0 01-60.1 0z\"/><path fill=\"#09F\" d=\"M160.6 305.2a42 42 0 010-59.8l101-100.2a42.7 42.7 0 0160 0 42 42 0 010 59.7L220.9 305.2a42.7 42.7 0 01-60.2 0z\"/><path fill=\"#FF6100\" d=\"M243.1 376.7a42 42 0 010-59.8l136.3-135.4a42.7 42.7 0 0160.2 0 42 42 0 010 59.8L303.3 376.7a42.7 42.7 0 01-60.2 0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "148 132.8 304 334.4"
  }
};